import React, { useContext, useEffect, useState } from 'react';
import Accordion from '@womcorp/wom-miwom-ui-kit/dist/components/Accordion/Accordion';
import { useMediaQuery } from 'react-responsive';
import * as custom from './CustomEntries';

import {
  MenuBodyContainerStyled,
  MenuBodyCategoryStyled,
  AccordionContainerStyled,
  MenuBodySubCategoryStyled,
  MenuBodySubCategoryInfoContainerStyled,
  SeparatorStyled,
  MenuEntryStyled,
  FooterContainerStyled,
  BottomPaddingContainerStyled,
} from './styles/MenuStyled';
import AppContext from '../App/AppContext';
import { useGlobalData } from '../../contextProvider/GlobalDataContext';
import { redirectInternalOrExternal } from '../../helpers/Redirect';
import Chip from './Chip';
import { GoogleTagManager } from '../../helpers';
import PageContext from '../../contextProvider/PageContext';
import Logout from './Logout/Logout';

const Menu = () => {
  const { setShowMenuMobile } = useContext(AppContext);
  const { menuData } = useGlobalData();
  const {
    location: { pathname: actualPathname },
  } = useContext(PageContext);

  const [expanded, setExpanded] = useState('');

  const isMobileDevice = useMediaQuery({ maxWidth: 768 });

  const [current, setCurrent] = useState({ entry: '', subEntry: '' });

  const entries = menuData;

  const normalizePathname = pathname => {
    if (pathname?.endsWith('/')) {
      return pathname?.slice(0, -1);
    }
    return pathname;
  };

  const getCurrentEntries = () => {
    const updatedEntries = entries?.map(entry => {
      const normalizedActualPathname = normalizePathname(actualPathname);
      const normalizedEntryPathname = normalizePathname(entry?.pathname);

      const isEntryMatch = normalizedEntryPathname === normalizedActualPathname;
      const updatedSubMenu = entry?.subMenu?.map(subEntry => {
        const normalizedSubEntryPathname = normalizePathname(
          subEntry?.pathname
        );
        return {
          ...subEntry,
          current: normalizedSubEntryPathname === normalizedActualPathname,
        };
      });

      return {
        ...entry,
        current:
          isEntryMatch || updatedSubMenu?.some(subEntry => subEntry?.current),
        subMenu: updatedSubMenu,
      };
    });

    const {
      entry: newCurrentEntry,
      subEntry: newCurrentSubEntry,
    } = updatedEntries.reduce(
      (acc, entry) => {
        return {
          entry: entry?.current ? entry?.name : acc?.entry,
          subEntry:
            entry?.subMenu?.find(subEntry => subEntry?.current)?.name ||
            acc?.subEntry,
        };
      },
      { entry: '', subEntry: '' }
    );

    return { newCurrentEntry, newCurrentSubEntry };
  };

  useEffect(() => {
    const { newCurrentEntry, newCurrentSubEntry } = getCurrentEntries();

    setExpanded(newCurrentEntry);

    setCurrent({
      entry: newCurrentEntry,
      subEntry: newCurrentSubEntry,
    });
  }, [actualPathname]);

  useEffect(() => {
    const { newCurrentEntry } = getCurrentEntries();
    if (!expanded) {
      setExpanded(newCurrentEntry);
    }
  }, [expanded]);

  const onClickEntry = entry => {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Elemento Menú',
      eventAction: `Presionar Botón - ${entry?.name}`,
      eventTag: `Elemento Menú - ${isMobileDevice ? 'Burger' : 'Side'}`,
    });

    if (entry?.pathname) {
      redirectInternalOrExternal(entry?.pathname);
      if (isMobileDevice) {
        setShowMenuMobile(false);
      }
    }
  };

  const categoryEntry = entry => {
    return (
      <MenuBodyCategoryStyled
        key={entry?.name}
        onClick={() => {
          onClickEntry(entry);
        }}
        active={current?.entry === entry?.name}
      >
        <MenuEntryStyled>
          <span>{entry?.name}</span>
        </MenuEntryStyled>
      </MenuBodyCategoryStyled>
    );
  };

  const subCategoryEntry = subEntry => {
    return (
      <MenuBodySubCategoryStyled
        key={subEntry?.name}
        onClick={() => {
          onClickEntry(subEntry);
        }}
      >
        <MenuBodySubCategoryInfoContainerStyled
          active={current?.subEntry === subEntry?.name}
        >
          <div>
            <img src={subEntry?.icon} alt={subEntry?.icon} />
          </div>
          <span>{subEntry?.name}</span>
        </MenuBodySubCategoryInfoContainerStyled>
        {subEntry?.isNew && <Chip label="Nuevo" />}
      </MenuBodySubCategoryStyled>
    );
  };
  return (
    <MenuBodyContainerStyled>
      {entries.map((entry, index) => {
        const isLastEntry = index === entries.length - 1;
        const SpecialComponentEntry = entry?.customComponent
          ? custom[entry.customComponent]
          : null;
        if (entry?.pathname) {
          return (
            <div key={entry.name}>
              {SpecialComponentEntry ? (
                <SpecialComponentEntry baseComponent="div">
                  {categoryEntry(entry)}
                </SpecialComponentEntry>
              ) : (
                categoryEntry(entry)
              )}
              {!isLastEntry && <SeparatorStyled />}
            </div>
          );
        }

        if (entry?.subMenu) {
          return (
            <div key={entry?.name}>
              <AccordionContainerStyled key={entry?.name}>
                <Accordion
                  key={entry?.name}
                  title={entry?.name}
                  expanded={expanded === entry?.name}
                  handleExpandOneAccordion={(e, newExpanded) => {
                    if (newExpanded) {
                      setExpanded(entry?.name);
                    } else if (current?.entry === entry?.name) {
                      setExpanded('none');
                    } else {
                      setExpanded('');
                    }
                  }}
                  variant="menu"
                  additionalInfoTitleContent={
                    entry?.isNew ||
                    entry?.subMenu?.some(subEntry => subEntry?.isNew) ? (
                      <Chip label="Novedades" />
                    ) : null
                  }
                >
                  {entry?.subMenu.map(subEntry => {
                    const SpecialComponentSubEntry = subEntry?.customComponent
                      ? custom[subEntry.customComponent]
                      : null;
                    return SpecialComponentSubEntry ? (
                      <SpecialComponentSubEntry
                        baseComponent="div"
                        key={subEntry?.name}
                      >
                        {subCategoryEntry(subEntry)}
                      </SpecialComponentSubEntry>
                    ) : (
                      subCategoryEntry(subEntry)
                    );
                  })}
                </Accordion>
              </AccordionContainerStyled>
              {!isLastEntry && <SeparatorStyled />}
            </div>
          );
        }
        return null;
      })}
      <BottomPaddingContainerStyled>
        <FooterContainerStyled>
          <Logout />
        </FooterContainerStyled>
      </BottomPaddingContainerStyled>
    </MenuBodyContainerStyled>
  );
};

export default Menu;
